import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import PlayerFooterButton from "core/components/PlayerFooterButton";

export default function RelatedButton({ onClick }) {
  const { t } = useTranslation("core");

  return (
    <PlayerFooterButton title={t("relatedButton.title")} onClick={onClick}>
      <VideoLibraryIcon />
    </PlayerFooterButton>
  );
}

RelatedButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
